import call from "./service/http";
import constants from "./feedbackConstants";

export default {
  namespaced: true,
  state: {
    question: [],
    feedback: {},
    feedbackDocument: "",
    questionnaireDocument: "",
    companyInformation: {},
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    feedbackGetters: (state) => (val) => state[val],
  },
  actions: {
    getCompanyInformation: ({ commit }) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.companyInformation).then((res) => {
        commit("MUTATE", {
          state: "companyInformation",
          data: res.data.data,
        });
        commit("loader/SET_LOADING", false, { root: true });
      });
    },
    getQuestion: ({ commit }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.question(data))
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "question", data: res.data.data[0] });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    getQuestionnaireDocument: ({ commit }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.questionnaireDocument, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "questionnaireDocument",
            data: res.data.data[0],
          });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    giveFeedback: ({ commit }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.feedback, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.data);
          Event.$emit("fetchDocument");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    getFeedbackDocument: ({ commit }, data) => {
      console.log(data);
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.feedbackDocument, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "feedbackDocument",
            data: res.data.data,
          });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
  },
};
